// app/not-found.tsx
'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import BackButton from "../components/profiles/shared/navigation/BackButton";
import './not-found.css';

const NotFoundPage = () => {
  const router = useRouter();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BackButton defaultRoute="/" />
      <div className="notfound-page">
        <div className="notfound-content">
          <h1 className="notfound-title">404</h1>
          <p className="notfound-subtitle">This page could not be found.</p>
          <p className="notfound-description">
            It looks like the path you followed doesn't lead anywhere.
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
